import React from 'react';
import GridCard from './_GridCard';
import { AccProps } from './_AccessorySlider';
import { appConfig } from '../../utils/appConfig';
import { useIsMobile } from '../../utils/useMediaQuery';
import { classNames } from '@repo/ui/src/utils/classNames';

interface AccGridProps extends AccProps {
  reverse?: boolean;
  accessories: any;
}

const AccGrid = ({ accessories, reverse }: AccGridProps) => {
  const isMobile = useIsMobile();
  const isMeaterMobile = appConfig.isMeater && isMobile;

  return (
    accessories && (
      <div className="px-6 md:px-12 mx-auto w-fit ">
        <ul
          className={classNames(
            'list-none max-w-[1680px]',
            appConfig.isMeater
              ? 'grid grid-cols-1 gap-6 sm:grid sm:gap-[1.6666vw] sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4'
              : 'flex gap-[1.6666vw] sm:grid sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4',
          )}
        >
          {accessories.map((accessory: any, i: any) => (
            <GridCard {...accessory} key={i} index={i} reverse={reverse} isMeaterMobile={isMeaterMobile} />
          ))}
        </ul>
      </div>
    )
  );
};

export default AccGrid;
